import { toast } from 'sonner';
import { API_ENDPOINTS, HTTP_METHODS } from '../config/api';
import { BaseApiService, ApiResponse } from './baseApi';

export interface WorkArea {
  id: number;
  workAreaName: string;
  code?: string;
  isActive: boolean;
  branchId?: number;
}

class WorkAreaApiService extends BaseApiService {
  async getActiveByBranch(branchId: number): Promise<WorkArea[]> {
    if (!branchId) return [];
    try {
      const url = API_ENDPOINTS.WORK_AREAS.ACTIVE;
      const response = await this.makeRequest<ApiResponse<WorkArea[]>>(url, { method: HTTP_METHODS.GET });
      if (response.success) return response.data;
      throw new Error(response.message || 'Failed to fetch work areas');
    } catch (error) {
      // console.error('Error fetching work areas by branch:', error);
      toast.error('Failed to load work areas');
      throw error;
    }
  }
}

export const workAreaApiService = new WorkAreaApiService();


